import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import WorkIcon from '@mui/icons-material/Work';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import { PATHS } from 'config/paths';
import { NavAction } from '../types';

export const Footer = () => {
  const { pathname } = useLocation();

  const navLinks: NavAction[] = [
    {
      path: PATHS.weeks,
      icon: <WorkIcon />,
      ariaLabel: 'work-overview'
    },
    { path: PATHS.account, icon: <AccountBoxIcon />, ariaLabel: 'settings' }
  ];

  const match = navLinks.find(navLink => pathname.includes(navLink.path));

  const [value, setValue] = useState<string | undefined>(match?.path);

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 80,
        borderTop: '1px solid #eee'
      }}
    >
      <BottomNavigation
        value={value}
        sx={{
          height: '100%',
          justifyContent: { sm: 'space-evenly' }
        }}
        onChange={(_event: any, value: string) => setValue(value)}
      >
        {navLinks.map(({ path, icon, ariaLabel }: NavAction) => (
          <BottomNavigationAction
            key={path}
            component={Link}
            icon={icon}
            value={path}
            to={path}
            disabled={pathname === path}
            aria-label={ariaLabel}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};
